module.exports = __webpack_public_path__ + "img/800CERVEZA.95d219df.png";